import { render, staticRenderFns } from "./payorder.vue?vue&type=template&id=2196185c&scoped=true&"
import script from "./payorder.vue?vue&type=script&lang=js&"
export * from "./payorder.vue?vue&type=script&lang=js&"
import style0 from "./payorder.vue?vue&type=style&index=0&id=2196185c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196185c",
  null
  
)

export default component.exports